import { useLocalization as e } from "../localization/index.js";
import { computed as t, createElementBlock as n, createElementVNode as r, createTextVNode as i, createVNode as a, defineComponent as o, openBlock as s, renderSlot as c, toDisplayString as l, unref as u } from "vue";
import { ScalarIconHash as d } from "@scalar/icons";
//#region src/schema/components/CopyLinkButton.vue?vue&type=script&setup=true&lang.ts
var f = { class: "sr-only" }, p = /*@__PURE__*/ o({
	__name: "CopyLinkButton",
	props: {
		anchorId: {},
		eventBus: {}
	},
	setup(o) {
		let { translate: p } = e(), m = t(() => p("actions.copyLinkTo", { name: o.anchorId.split(".").pop() ?? "" }));
		return (e, t) => (s(), n("button", {
			class: "copy-link-trailing text-c-3 hover:text-c-1 -my-1.25 ms-1.25! -me-1.25! flex shrink-0 cursor-pointer items-center justify-center self-center p-1.25 opacity-0 group-hover:opacity-100 focus-visible:opacity-100 pointer-coarse:hidden",
			type: "button",
			onClick: t[0] ||= () => o.eventBus?.emit("copy-url:nav-item", { id: o.anchorId })
		}, [a(u(d), {
			"aria-hidden": "true",
			class: "size-3.5"
		}), r("span", f, [c(e.$slots, "sr-label", {}, () => [i(l(m.value), 1)])])]));
	}
});
//#endregion
export { p as default };

//# sourceMappingURL=CopyLinkButton.vue.script.js.map